export default "__VITE_ASSET__dsdDqkFU__"